import { ItemMenu, MenuService } from "./../services/menu.service";
import { AuthService } from "./../services/auth.service";
import { AtividadeUsuarioService } from "./../services/atividade-usuario.service";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss", "../app.component.css"],
})
export class SideMenuComponent implements OnInit {
  logoLoja: string;

  constructor(
    private atividadeUsuario: AtividadeUsuarioService,
    private authService: AuthService,
    public menuService: MenuService,
    private router: Router,
    public appService: AppService
  ) { }

  ngOnInit(): void {
    this.logoLoja = this.authService.usuario.Logo;
  }

  clickMenu(menu: ItemMenu) {
    if (!!menu.path) {
      this.router.navigateByUrl(menu.path);
      this.menuService.menuAtivo = menu.id;
    }

    if (!!menu.action) {
      menu.action();
    }

    if (this.appService.modoMobileEstaAtivado) {
      this.appService.toggleSideBar();
    }
  }

  updateAtividade() {
    this.atividadeUsuario.registrar();
  }
}
